import { Store } from '@ngrx/store';
import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component, Output, EventEmitter, HostListener, AfterViewInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { AppState } from '../../../interfaces/app-state.interface';

@Component({
    selector: "tr-money",
    templateUrl: "./tr-money.component.html",
    styleUrls: ["./tr-money.component.scss"],
})
export class TrMoneyComponent
    extends TrInputComponent
    implements AfterViewInit
{
    @Output() public onEnterKeyDown: EventEmitter<Event> =
        new EventEmitter<Event>();
    @ViewChild("formInput", { static: true }) public formInput: ElementRef;

    constructor(private render: Renderer2, store: Store<AppState>) {
        super(store);
    }

    public onEnterKeyDownHandler(event: Event) {
        this.onEnterKeyDown.emit(event);
    }

    @HostListener("document:keydown", ["$event"]) public onKeydownHandler(
        event: KeyboardEvent
    ) {
        if (event.keyCode === 189) return false;
    }

    public ngAfterViewInit() {
        //
    }
}
